import { getSvgIcon } from '@helpers/icons';
import * as React from 'react';
import S from './SocialLinks.styles';
export var SocialMediaIcon;
(function (SocialMediaIcon) {
    SocialMediaIcon["Facebook"] = "facebook";
    SocialMediaIcon["FounderResources"] = "founder-resources";
    SocialMediaIcon["G2"] = "g2";
    SocialMediaIcon["Instagram"] = "instagram";
    SocialMediaIcon["LinkedIn"] = "linkedin";
    SocialMediaIcon["Pinterest"] = "pinterest";
    SocialMediaIcon["X"] = "x";
    SocialMediaIcon["YouTube"] = "youtube";
})(SocialMediaIcon || (SocialMediaIcon = {}));
const SocialLinks = (props) => {
    return (React.createElement(S.Container, null, props.items.map((item) => (React.createElement(S.Item, { key: item.id },
        React.createElement(S.Link, { href: item.url, rel: "noreferrer noopener", target: "_blank", title: item.title }, renderIcon(item.type)))))));
    function renderIcon(type) {
        if (!Object.values(SocialMediaIcon).includes(type)) {
            console.error(`Unsupported icon type`, type);
            return null;
        }
        return getSvgIcon(type);
    }
};
export default SocialLinks;
